import { z } from 'zod';
export const COMPANIONS = [
    {
        key: 'quinn-quokka',
        name: 'Quinn the Quokka',
        blurb: 'Always smiling, always ready for an adventure.',
        unlock: 'start',
    },
    {
        key: 'rex-rumble',
        name: 'Rex Rumble',
        blurb: 'A little dinosaur with a very big roar.',
        unlock: 'start',
    },
    {
        key: 'wanda-wombat',
        name: 'Wanda Wombat',
        blurb: 'Plays footy, digs tunnels, never gives up.',
        unlock: 'start',
    },
    {
        key: 'bly-bilby',
        name: 'Bly the Bilby',
        blurb: 'Sings every answer, sometimes twice.',
        unlock: 'start',
    },
    {
        key: 'bolt-bot',
        name: 'Bolt',
        blurb: 'A helpful little robot who loves a puzzle.',
        unlock: 'start',
    },
    {
        key: 'tilly-turtle',
        name: 'Tilly Turtle',
        blurb: 'Slow and steady, and she gets there every time.',
        unlock: 'start',
    },
];
export const COMPANION_KEYS = COMPANIONS.map((c) => c.key);
export const companionKeySchema = z.enum(COMPANION_KEYS);
export const DEFAULT_COMPANION = 'quinn-quokka';
export function findCompanion(key) {
    if (!key)
        return undefined;
    return COMPANIONS.find((c) => c.key === key);
}
//# sourceMappingURL=companions.js.map